import { configureStore } from '@reduxjs/toolkit';
import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector,
  useStore,
} from 'react-redux';
import appGlobalReducer from './reducers/appGlobalSlice';
import sosSliceReducer from './reducers/sosSlice';
import ogpoVtsReducer from './reducers/ogpoVtsSlice';
import accidentReducer from './reducers/accidentSlice';
import asylReducer from './reducers/asylSlice';
import abroadReducer from './reducers/abroadSlice';
import flutterHomeReducer from './reducers/flutterHomeSlice';
import pageSliceReducer from './reducers/pageSlice';
import departmentSliceReducer from './reducers/departmentSlice';
import newsSliceReducer from './reducers/newsSlice';
import newsDetailSliceReducer from './reducers/newsDetailSlice';
import promotionsSliceReducer from './reducers/promotionsSlice';
import promotionsDetailSliceReducer from './reducers/promotionsDetailSlice';
import agentFormSliceReducer from './reducers/agentFormSlice';
import lossBsosReducer from './reducers/lossBsosSlice';
import lossBsosDetailReducer from './reducers/lossBsosDetailSlice';
import cascoLimitReducer from './reducers/cascoLimitSlice';
import bankSlice from './reducers/bankSlice';
import myCarSlice from '../features/mycar/mycar-slice';
import collateralPropertySliceReducer from './reducers/collateralPropertySlice';
import vvSlice from '../features/vv/vv-slice';

const store = configureStore({
  reducer: {
    appGlobal: appGlobalReducer,
    ogpoVts: ogpoVtsReducer,
    sosSlice: sosSliceReducer,
    accidentSlice: accidentReducer,
    asylSlice: asylReducer,
    abroadSlice: abroadReducer,
    flutterHomeSlice: flutterHomeReducer,
    pageSlice: pageSliceReducer,
    departmentSlice: departmentSliceReducer,
    newsSlice: newsSliceReducer,
    newsDetailSlice: newsDetailSliceReducer,
    lossBsosSlice: lossBsosReducer,
    lossBsosDetailSlice: lossBsosDetailReducer,
    promotionsSlice: promotionsSliceReducer,
    promotionsDetailSlice: promotionsDetailSliceReducer,
    agentFormSlice: agentFormSliceReducer,
    cascoLimitSlice: cascoLimitReducer,
    bankSlice,
    myCar: myCarSlice,
    collateralPropertySlice: collateralPropertySliceReducer,
    vv: vvSlice,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;

export type AppStore = typeof store;
export const useAppStore: () => AppStore = useStore;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export type RootState = ReturnType<AppStore['getState']>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
